module.exports = __webpack_public_path__ + "img/sftp.28eb363.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/integrations/sftp.png
// module id = 3+SW
// module chunks = 38 43